export default "__VITE_ASSET__DRHjqh8M__"